module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 291);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toggle = __webpack_require__(292);

var _Toggle2 = _interopRequireDefault(_Toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Toggle2.default;

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Toggle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _general = __webpack_require__(293);

var _general2 = _interopRequireDefault(_general);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Toggle(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange,
      name = _ref.name;

  var inputProps = {
    checked: checked,
    className: _general2.default.input,
    name: name,
    type: 'checkbox',
    onChange: onChange
  };

  var indicatorProps = {
    className: (0, _classnames2.default)(_general2.default.indicator, {
      'bg-green': checked,
      'bg-black': !checked
    }),
    style: {
      width: '60px',
      height: '30px',
      borderRadius: '30px'
    }
  };

  var circleProps = {
    className: (0, _classnames2.default)(_general2.default.circle, _defineProperty({}, _general2.default.activeCircle, checked)),
    style: {
      width: '16px',
      height: '16px',
      margin: '7px'
    }
  };

  return _react2.default.createElement(
    'label',
    { className: _general2.default.control },
    _react2.default.createElement('input', inputProps),
    _react2.default.createElement(
      'div',
      indicatorProps,
      _react2.default.createElement('div', circleProps)
    )
  );
}

Toggle.propTypes = {
  checked: _propTypes2.default.bool.isRequired,
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

Toggle.defaultProps = {
  checked: false
};

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"control":"general__control___3HvTB cursor-pointer display-block position-relative userSelect-none","input":"general__input___3hfBb opacity-0 position-absolute zi-negative","indicator":"general__indicator___3UiRx position-relative display-block transitionDuration-m userSelect-none","circle":"general__circle___3TQ-E position-absolute pinTL bg-white borderRadius-circle transitionDuration-m","activeCircle":"general__activeCircle___1qIKb"};

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-toggle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-toggle.js
// module id = 519
// module chunks = 18116671869107 156544657062075